/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![EducationIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABqElEQVR4nO2TzytEURTHx8/kH2BhqbC3VLNgpXd+jLpzzqTMbthayEpj50+QbCh7xcaPjbDVbIQioqSUDSmUH53H9OaNYd4zs3TqW/edd+/ne++59yQS/1GP8DyvHUimgfXCF8m05WoG53K5FmDJAcs1sr6HRHprRslsti02OJ/PN2JKHJCefQOXCVivbBPJZLI5CrvBB7OeVAPjd52bkXOuqSIZMT2EpAd/AL+HJYe2SdtsACfZqh2s5aXbDgxYF4DkpW5w8lkLoRKlUqNdtYP1DkjnjFX5HoLJE0hyHAN8RJQZr9obxQXFb48zA0i6jqxvFeGk+0QZCF1oVANE7XfOtdqYWfqAZB5Y732RzHsjmV77Z3MwlR4FlsVYBkDyiqQ3yJofdq6z2IAmG1sOSGa/5oRO/rMByR6w7paa4WeNn4F0xUpmsrHlyksWqUwlZjtxX9GvQGDNIuuTL0yPIepkTIPTKvWX1ZJ2X/VIBiOC34BlDUA7qpxACkGbS8HPgetGlikk3bS3DqQPyPqIrJfAsgEkM4iuJ1LNgXU5eN+yFGnRfyTqEB86oNuiWUU8jQAAAABJRU5ErkJggg==)
 */
export const EducationIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22.56 9.63 12.8 13.9a2 2 0 0 1-1.6 0L5 11.19V15a1 1 0 1 1-2 0v-4.69l-1.56-.68a.75.75 0 0 1-.05-1.35l9.69-5.05a2 2 0 0 1 1.84 0l9.69 5.05c.56.29.53 1.1-.05 1.35Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M6.98 18.98a.48.48 0 0 1-.28-.38l-.18-1.43a1 1 0 0 0-.1-.32l-.37-.74a.5.5 0 0 1-.05-.23v-1.7c0-.35.37-.6.7-.45l4.9 2.1c.26.1.54.1.8 0l5.9-2.53c.33-.14.7.1.7.46v3.44c0 .2-.05.39-.18.54C17.65 19.11 14.65 20 12 20c-1.73 0-3.6-.38-5.02-1.02ZM3.38 17a1 1 0 0 0-.99.88l-.25 2a1 1 0 0 0 1 1.12h1.73a1 1 0 0 0 .99-1.12l-.25-2a1 1 0 0 0-1-.88H3.39Z"
        className={colorClass}
      />
    </svg>
  );
};
